import script from "./modelDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./modelDialog.vue?vue&type=script&setup=true&lang=js"

import "./modelDialog.vue?vue&type=style&index=0&id=1060f274&scoped=true&lang=scss"

import exportComponent from "D:\\Projects\\learning-center\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1060f274"]])

export default __exports__